import fitvids from 'fitvids'
import { GetStaticPaths, GetStaticProps } from 'next'
import { useEffect } from 'react'
import { BlogPost } from '../../components/blog/BlogTypes'
import SEOMetaTags from '../../components/seo/SEOMetaTags'
import Footer from '../../components/shared/Footer'
import FloatingCta from '../../components/shared/FloatingCta'
import Header from '../../components/shared/Header'
import Wrapper from '../../components/shared/Wrapper'
import RelatedPostsList from '../../components/single-blog-post/RelatedPostsList'
import SharePost from '../../components/single-blog-post/SharePost'
import SinglePostHeader from '../../components/single-blog-post/SinglePostHeader'
import {
  cropImageFromCdn,
  getAllPostsWithSlug,
  getPostAndRelatedPosts,
} from '../../lib/fetchBlog'
import { baseDomain } from '../../util/baseDomain'
import styles from './blogpost.module.css'

interface SinglePostProps {
  post: BlogPost
  relatedPosts: BlogPost[]
}

export default function SinglePost({
  post,
  relatedPosts,
}: SinglePostProps): JSX.Element {
  useEffect(() => {
    fitvids()
  }, [])

  return (
    <div className="relative">
      <SEOMetaTags
        title={post?.title ?? 'Sukha Blog'}
        description={post?.summary ?? ''}
        url={baseDomain() + `/blog/${post?.slug}`}
        imageUrl={cropImageFromCdn(post?.featured_image, 1200 / 2, 627 / 2)}
      />

      <Header />

      {post && (
        <>
          <SinglePostHeader post={post} />
          <FloatingCta 
            source={`post_${post.slug}`}
            noGoogleAuthSource={`post_${post.slug}_no_google`}
          />

          <Wrapper>
            <div className="lg:flex my-20 justify-between relative">
              <div
                className={`prose-lg max-w-2xl prose-pink mx-auto ${styles.post}`}
                dangerouslySetInnerHTML={{ __html: post?.body ?? '' }}
              />

              <div className="mt-20">
                <SharePost
                  link={`/post/${post.slug}`}
                  title={post.title ?? ''}
                />
              </div>
            </div>

            <RelatedPostsList relatedPosts={relatedPosts} />
          </Wrapper>
        </>
      )}

      <Footer />
    </div>
  )
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = (params?.slug ?? '') as string
  const { post, relatedPosts } = await getPostAndRelatedPosts(slug)

  return {
    props: {
      post,
      relatedPosts,
    },
    revalidate: 10,
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const allPosts = await getAllPostsWithSlug()

  return {
    paths: allPosts?.slice(0, 10)?.map((post) => `/post/${post.slug}`) || [],
    fallback: true,
  }
}
